import { Registry } from '@react-registry'

export const H2Deserializer = () => {
  return {
    type: 'h2'
  }
}

Registry.register(H2Deserializer, { id: 'H2', registry: 'v2.deserializer' })
